import BlogMidCTA from "../../../../src/components/BlogMidCTA";
import { DateTimeFormatExample, DateTimeFormatPartsExample, RelativeTimeFormatExample, DurationFormatExample, NumberFormatExample, CurrencyLocaleComparisonExample, UnitFormatExample, ListFormatExample, PluralRulesExample, SegmenterExample, CollatorExample } from "../../../../src/components/intlapi/examples";
import * as React from 'react';
export default {
  BlogMidCTA,
  DateTimeFormatExample,
  DateTimeFormatPartsExample,
  RelativeTimeFormatExample,
  DurationFormatExample,
  NumberFormatExample,
  CurrencyLocaleComparisonExample,
  UnitFormatExample,
  ListFormatExample,
  PluralRulesExample,
  SegmenterExample,
  CollatorExample,
  React
};